module.exports = __webpack_public_path__ + "img/Affiliate-Banner-desktop.e242b40.jpg";